import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import useApi from '../../api/useApi';
import Moment from 'react-moment';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import moment from 'moment'; //Both are required here
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const PooledLotAuditTrail = () => {
    const navigate = useNavigate();
    const [modalVisible, setModalVisible] = useState(false);
    const [editPoolingDetail, setEditPoolingDetail] = useState({});
    const [isPoolingClosed, setIsPoolingClosed] = useState(false);
    const api = useApi();
    const [pooledLots, setPooledLots] = useState([]);
    const [auctionDetail, setAuctionDetail] = useState({});
    const [isAuctionScheduled, setIsAuctionScheduled] = useState(false);
    const [dealerQtyPercent, setDealerQtyPercent] = useState(0);
    const { id } = useParams();
    const [auctionId, setAuctionId] = useState(id);
    const [gridApi, setGridApi] = useState(null);

    const planterDealerRenderer = (props) => {
        const planterOrDealer = (props.value === 1 ? "Planter" : (props.value === 2 ? "Dealer" : props.value));
        return (
            <span>{planterOrDealer} </span>
        );
    };



    const specialLotRenderer = (props) => {
        const isSpecialLot = (props.isSpecialLot === true ? "Yes" : (props.value === false ? "No" : props.value));

        return (
            <span>{isSpecialLot} </span>
        );
    };

    const poolingStatusRenderer = (props) => {
        const isClosed = (props.value === true ? "Pooling closed" : (props.value === false ? "Open" : props.value));
        return (
            <span>{isClosed} </span>
        );
    };

    const buttonRenderer = (props) => {
        const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
        return (
            <span>
                <span role="button" className="custom-link" onClick={() => downloadCropReceipt(props.node.data.pooledLotId)}>{cellValue}</span>
            </span>
        );
    };

    const linkRenderer = (props) => {
        if (props.value === 1)
            return <div> <span style={{ fontSize: '12px' }}  className="badge  bg-success"> Added</span></div> 
        else if (props.value === 2)
            return <div> <span style={{ fontSize: '12px' }} className="badge  bg-warning"> Modified</span></div > 
        else if (props.value === 3)
            return <div> <span style={{ fontSize: '12px' }} className="badge bg-danger"> Deleted</span></div > 

    };

    const dateRenderer = (props, format) => {
        const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
        return (
            <span>
                <span>{cellValue ? <Moment format={format}>{cellValue}</Moment> : null}</span>
            </span>
        );
    };

    const columns = [
        { headerName: 'Lot No.', field: 'lotNumber', headerClass: 'text-center', cellClass: 'text-center', width: 40, },
        { headerName: 'Operation Type', field: 'operationType', headerClass: 'text-center', cellClass: 'text-center', width: 90, cellRenderer: linkRenderer },
        { headerName: 'Operation Date', field: 'operationDate', headerClass: 'text-center', cellClass: 'text-center', width: 160, cellRenderer: (props) => dateRenderer(props, 'DD-MMM-YYYY LT') },
        { headerName: 'Operation By', field: 'operationBy', headerClass: 'text-center', cellClass: 'text-center', width: 120, },
        { headerName: 'Collection Center', field: 'collectionCenter', cellClass: 'text-center', width: 120 },
        { headerName: 'Planter/ Dealer', field: 'planterDealer', cellClass: 'text-center', width: 68, cellRenderer: planterDealerRenderer },
        { headerName: 'Planter Name', field: 'planterName', cellClass: '', width: 240 },
        { headerName: 'Planter Mobile Number', field: 'planterMobileNumber', width: 100 },
        { headerName: 'CRNO/ SBL No', field: 'crnosblNo', width: 'auto' },
        { headerName: 'Litre Weight (gm)', field: 'litreWeightGms', headerClass: 'text-center', cellClass: 'text-center', width: 64 },
        { headerName: 'No. of Bags', field: 'bags', headerClass: 'text-center', cellClass: 'text-center', width: 48 },
        { headerName: 'Qty (Kg)', field: 'quantityKg', headerClass: 'text-center', cellClass: 'text-center', width: 64 },
        { headerName: 'Grade Type', field: 'gradeType', cellClass: 'text-center', width: 60 },
        { headerName: 'Grade', field: 'grade', cellClass: 'text-center', width: 90 },
        { headerName: 'Moisture Content (%)', field: 'moistureContent', headerClass: 'text-center', cellClass: 'text-center', width: 78 },
        { headerName: 'Immature Seeds (%)', field: 'immatureSeeds', headerClass: 'text-center', cellClass: 'text-center', width: 78 },
        { headerName: 'Size', field: 'size', cellClass: 'text-center', width: 90 },
        { headerName: 'Colour', field: 'colour', cellClass: 'text-center', width: 90 },
        { headerName: 'Rejection', field: 'rejection', cellClass: 'text-center', width: 90 },
        { headerName: 'Is Speical Lot', field: 'isSpecialLot', cellClass: 'text-center', width: 90, cellRenderer: specialLotRenderer },
        { headerName: 'Start Price', field: 'auctionStartPriceRs', cellClass: 'text-center', width: 60 },
        { headerName: 'Res. Price', field: 'reservedPrice', cellClass: 'text-center', width: 60 },
        { headerName: 'Crop Receipt Number', field: 'cropReceiptNumber', cellClass: 'text-center', width: 250, cellRenderer: buttonRenderer },
        { headerName: 'Pooling Status', field: 'isPoolingClosed', cellClass: 'text-center', width: 140, cellRenderer: poolingStatusRenderer },
    ];

    const gridOptions = {
        defaultColDef: {
            wrapHeaderText: true,
            autoHeaderHeight: true,
        },
        columnDefs: columns,
        rowClass: 'custom-grid-font',
        getRowClass: params => {
            if (params.node.rowIndex % 2 === 0) {
                return 'bg-gray-50-i';
            }
        }
    };


    const loadPooledLotAuditTrail = async () => {
        try {
            const pooling = await api.getPooledLotAuditTrail(auctionId);

            setPooledLots(pooling);


        } catch (error) {
            alert('Unable to fetch pooled lot audit trail data.');
        }
    };

    useEffect(() => {
        loadPooledLotAuditTrail();
    }, []);


    const viewPoolingDetail = (pooledLotId) => {
        navigate(`/pooledLotView/${pooledLotId}`);
    };


    const viewAuditTrail = () => {
        navigate(`/pooledLotAuditTrail/${auctionId}`);
    };

    const downloadCropReceipt = async (id) => {

        const receiptData = await api.getCropReceipt(id);
        let rows = [];
        if (receiptData.isProvisionalCropReceipt === true)
            rows.push([{ text: "PROVISIONAL CROP RECEIPT", colSpan: 2, fontSize: 20, bold: true }, { text: "" }]);
        else
            rows.push([{ text: "CROP RECEIPT", colSpan: 2, fontSize: 20, bold: true }, { text: "" }]);

        rows.push([{ text: "Receipt No. " + receiptData.cropReceiptNumber, border: [true, false, false, true] }, { text: "Receipt Date : " + moment(receiptData.poolingDate).format('DD-MMM-YYYY'), alignment: "right", border: [false, false, true, true] }]);
        rows.push([{ text: "", colSpan: 2, margin: [0, 5, 0, 5] }, { text: "" }]);
        rows.push([{ text: "POOLING DETAIL", bold: true, colSpan: 2, fillColor: "#a2bbdb" }, { text: "" }]);
        rows.push([{ text: "Name Of Planter / Dealer / Contact No : " }, { text: receiptData.planterName + " / " + receiptData.planterMobileNumber, bold: true }]);
        rows.push([{ text: "Pooling Centre : " }, { text: receiptData.centerName, bold: true }]);
        rows.push([{ text: "Date of Pooling : " }, { text: moment(receiptData.poolingDate).format('DD-MMM-YYYY'), bold: true }]);
        rows.push([{ text: "CRNO/SBL No : " }, { text: receiptData.crnosblNo, bold: true }]);
        rows.push([{ text: "Lot Number : " }, { text: receiptData.lotNumber, bold: true }]);
        rows.push([{ text: "Number of bags : " }, { text: receiptData.bags, bold: true }]);
        rows.push([{ text: "Net Weight : " }, { text: receiptData.quantityKg + " kg", bold: true }]);
        rows.push([{ text: "Litre weight : " }, { text: receiptData.litreWeightGms + " gram", bold: true }]);
        rows.push([{ text: "", colSpan: 2, margin: [0, 5, 0, 5] }, { text: "" }]);
        rows.push([{ text: "AUCTIONEER DETAIL", bold: true, colSpan: 2, fillColor: "#a2bbdb" }, { text: "" }]);
        rows.push([{ text: "Auctioneer : " + receiptData.companyName, colSpan: 2 }, { text: "" }]);
        rows.push([{ text: "License No : " + receiptData.licenceNumber }, { text: "GST No : " + receiptData.gstNumber }]);
        rows.push([{ text: "Auction No. : " + receiptData.auctionNo }, { text: "Auction Date : " + moment(receiptData.auctionDate).format('DD-MMM-YYYY') }]);
        rows.push([{ text: "Payment Due Date : 10 days from the date of auction." }, { text: "" }]); //moment(receiptData.paymentDueDate).format('DD-MMM-YYYY') 
        rows.push([{ text: "", colSpan: 2, margin: [0, 5, 0, 5], border: [true, false, true, false] }, { text: "" }]);
        rows.push([{ text: "The Cardamom pooled with us will be sold through our auction subject to the terms and conditions of the Cardamom Auctioneer Licence issued by Spice Board. This Crop Receipt should be produced when claiming payment.", border: [true, false, true, false], colSpan: 2 }, { text: "" }]);
        rows.push([{ text: "", colSpan: 2, margin: [0, 40, 0, 40], border: [true, false, true, false] }, { text: "" }]);
        rows.push([{ text: "Customer Signature", alignment: "center", border: [true, false, false, false] }, { text: "Authorized Signatory", alignment: "center", border: [false, false, true, false] }]);
        rows.push([{ text: "", colSpan: 2, margin: [0, 5, 0, 5], border: [true, false, true, false] }, { text: "" }]);
        rows.push([{ text: "Sample taken: 3 Kg\nIf the lot is sold : Payment will be made for : (" + receiptData.quantityKg + "kg - 150gm) = " + (receiptData.quantityKg - 0.15) + " Kg.\nIf the lot is withdrawn before bidding : Whole sample will be returned.\nIf the lot is withdrawn after bidding : Payment will be made for 3000 gm based on the average price of that auction or return the sample in the form of cardamom mixed with other samples.\nIf the lot is detected with artificial colour, 2900 gm sample will be returned.", fontSize: 10, margin: [0, 10, 0, 10], colSpan: 2, border: [true, false, true, true] }, { text: "" }]);
        rows.push([{ text: "Software by Boltware | www.boltware.in", fontSize: 6, margin: [0, 20, 0, 20], colSpan: 2, border: [false, false, false, false] }, { text: "" }]);


        let body = rows;
        const documentDefinition = {
            content: [
                {
                    style: 'tableExample2',
                    table: {
                        //widths: [222,222],
                        body: body
                    }, layout: {
                        paddingLeft: (i, node) => 5,
                        paddingRight: (i, node) => 5,
                        paddingTop: (i, node) => 5,
                        paddingBottom: (i, node) => 5
                    }
                },
            ],
            styles: {
                tableExample2: {
                    width: '100%',
                    fontSize: 10, // Set the font size for the table
                },
            }
        };
        let filename = "Crop-Receipt-" + receiptData.cropReceiptNumber + ".pdf"
        pdfMake.createPdf(documentDefinition).download(filename);
    }

    const onGridReady = (params) => {
        setGridApi(params.api);
    };

    const downloadCSV = async (e) => {
        const params = {
            suppressQuotes: false,
            columnSeparator: ',',
        };

        const data = gridApi.getDataAsCsv(params);

        const blob = new Blob([data], { type: 'text/csv;charset=utf-8;' });
        const fileName = 'Pooling detail.csv';

        const link = document.createElement('a');
        if (link.download !== undefined) {
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
    return (
        <div>
            <div className="inner-body">
                <div className="page-header">
                    <div>
                        <h2 className="main-content-title tx-24 mg-b-5">Pooled Lot Audit Trail</h2>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"> <a className="custom-link" onClick={() => navigate(-1)}>Home</a></li>
                            <li className="breadcrumb-item"> <a className="custom-link" onClick={() => navigate(-1)}>Pooled Lots</a></li>
                            <li className="breadcrumb-item active" aria-current="page">Pooling Detail</li>
                        </ol>
                    </div>
                    {/*<div className="d-flex">*/}
                    {/*    {isAuctionScheduled === true && isPoolingClosed === false ?*/}
                    {/*        <div className="justify-content-center">*/}
                    {/*            */}{/*<button type="button" className="btn btn-success my-2 btn-icon-text" onClick={closePoolingAndForward}>*/}
                    {/*            */}{/*    <i className="fe fe-edit me-2"></i> Close pooling & forward lots for auction.*/}
                    {/*            */}{/*</button>*/}
                    {/*        </div> :*/}
                    {/*        isAuctionScheduled === true && isPoolingClosed === true ?*/}
                    {/*            <div><span style={{ fontSize: '13px' }} className="badge rounded-pill bg-success p-2 mg-b-5"> Pooling has been closed & lots has been forwarded for auction.</span></div>*/}
                    {/*        :null*/}
                    {/*    }*/}
                    {/*</div>*/}


                </div>
                <div className="row row-sm">
                    <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 grid-margin">
                        <div className="card custom-card">

                          
                                <div className="card-body">
                                    <div className="d-flex justify-content-end">

                                            <button className="btn btn-sm ripple btn-outline-primary fs-11 mb-2" onClick={(e) => downloadCSV(e)}> <i class="ti ti-import me-1"></i> Download CSV</button>
                                    </div>
                                    <div
                                        style={{ height: '90vh' }}
                                        className={
                                            "ag-theme-alpine"
                                        }
                                    >
                                        <AgGridReact gridOptions={gridOptions} rowData={pooledLots} onGridReady={onGridReady} /></div>
                                </div>  
                               

                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default PooledLotAuditTrail;